// extracted by mini-css-extract-plugin
module.exports = {"link":"_3dq7tgWcGItn4pSycto_Gk","underline":"_2PC1k3SGE79sIRqP1wXWRi","disabled":"_2VlYvXQYn050fY92q374nV","center":"GUXFbLzUyNmf3CkIlNlLu"};